import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBackToUpLeft = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 6H20V18H4V11.7432L2 9.74316V20H22V4H2.5V6Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M6 8.5L2.5 5L6 1.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowBackToUpLeft.js.map